// extracted by mini-css-extract-plugin
export var wordContainer = "_mr-0";